<template>
  <div class="copay-epa-source-pharmacy-setting">
    <b-table
      striped
      hover
      :busy.sync="busy"
      :fields="gridFields"
      :items="pharmacy_setting"
      :tbody-tr-class="rowClass"
    >
      <div slot="table-busy" class="text-center my-2">
        <i class="fa fa-spinner fa-pulse"></i>
        <strong>Working...</strong>
      </div>
      <template slot="file_source_name" slot-scope="data">
        <a
          href
          v-if="data.item.status !== 'deleted'"
          @click.prevent="$emit('edit', data.item)"
        >{{data.value}}</a>
        <span v-if="data.item.status === 'deleted'">{{data.value}}</span>
      </template>
      <template
        slot="current_status"
        slot-scope="data"
      >{{ getCurrentEffectiveStatus(data.item) | snakeToTitleCase}}</template>
      <template
        slot="status"
        slot-scope="data"
      >{{ data.value | snakeToTitleCase}}</template>
      <template slot="actions" slot-scope="data">
        <div
          v-if="getCurrentEffectiveStatus(data.item) !== 'new' && data.item.status === 'edit'"
        >
          <a href @click.prevent="$emit('view-active', data.item)">View Active</a>
        </div>
        <div v-if="isAdmin && (data.item.status === 'edit' || data.item.status === 'new')">
          <a href @click.prevent="$emit('request-approval', data.item)">Request Approval</a>
        </div>
        <div v-if="isApprover && data.item.status === 'pending_approval'">
          <a href @click.prevent="$emit('approve', data.item)">Approve</a>
        </div>
        <div v-if="isApprover && data.item.status === 'approved'">
          <a href @click.prevent="$emit('publish', data.item)">Publish</a>
        </div>
        <div
          v-if="isAdmin && data.item.status !== 'active' && data.item.status !== 'inactive' && data.item.status !== 'deleted' && data.item.status !== 'published'"
        >
          <a href @click.prevent="$emit('cancel-update', data.item)">Cancel</a>
        </div>
      </template>
    </b-table>
  </div>
</template>
<script>
export default {
  name: "VCopayEPAPharmacyFileSetting",
  props: {
    pharmacy_setting: {
      required: true,
      type: Array
    },
    busy: {
      required: false,
      type: Boolean
    },
    isAdmin: {
      required: false,
      type: Boolean
    },
    isApprover: {
      required: false,
      type: Boolean
    }
  },
  data() {
    return {
      gridFields: [
        {
          class: "id-field",
          key: "file_source_name",
          label: "Pharmacy Name",
          sortable: true
        },
        {
          key: "parser",
          class: "parser-field",
          sortable: true,
          formatter: value => {
            switch (value) {
              case "HorizonPineRidgeParser":
                return "Pine Ridge";
              case "HorizonHighlandParser":
                return "Highland";
              case "AllFieldsParser":
                return "All Fields";
            }
            return value;
          }
        },
        {
          key: "has_header",
          sortable: true,
          formatter: value => {
            return value ? "Yes" : "No";
          }
        },
        {
          key: "current_status",
          label: "Filter Status",
          sortable: true
        },
        {
          key: "status",
          label: "Workflow Status",
          sortable: true
        },
        {
          key: "actions",
          class: "action-field",
          label: "",
          sortable: false
        }
      ]
    };
  },
  methods: {
    rowClass(item, type) {
      const now = new Date().toISOString();
      if (!item) return;
      if (
        item.is_pending_inactivation ||
        item.current_status === "inactive" ||
        item.current_status === "deleted" ||
        (item.current_filter_start_date &&
          item.current_filter_end_date &&
          (now < item.current_filter_start_date || item.current_filter_end_date < now))
      ) {
        return "table-warning";
      }
    },
    getCurrentEffectiveStatus(item) {
      const now = new Date().toISOString();
      if (
        item.current_filter_start_date &&
        now < item.current_filter_start_date
      ) {
        return `inactive until ${new Date(
          item.current_filter_start_date
        ).toLocaleDateString()}`;
      } else if (
        item.current_filter_end_date &&
        item.current_filter_end_date < now
      ) {
        return "inactive";
      } else if (
        item.current_status === "active" &&
        item.current_filter_end_date &&
        item.current_filter_end_date > now &&
        item.current_filter_end_date.indexOf("2099-01-01") === -1
      ) {
        return `active until ${new Date(
          item.current_filter_end_date
        ).toLocaleDateString()}`;
      }
      return item.current_status;
    }
  }
};
</script>

<style lang="scss">
.copay-epa-source-pharmacy-setting {
  .id-field {
    width: 300px;
  }
  .parser-field {
    width: 400px;
  }
  .action-field {
    width: 150px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/VCopayEPAPharmacySettings.vue